import { lazyLoad } from '../../../core/utils/loadable';

export const BusinessesPage = lazyLoad(
  () => import('./index'),
  (module) => module.Businesses,
);
